module.exports = __webpack_public_path__ + "img/calendar-clock-primary.ee20d4a.png";